import {FuseRouteItemType} from '@fuse/utils/FuseUtils';

import {AUTH_ROLES} from '@/app/auth/authRoles';

import ParentRedirectionPage from './ParentRedirectionPage';

const ParentRedirectionRoute: FuseRouteItemType = {
  path: 'parent/redirection',
  element: <ParentRedirectionPage />,
  auth: AUTH_ROLES.parent,
};

export default ParentRedirectionRoute;
